<template>
 <MainMap/>
</template>

<script>
import MainMap from './components/MainMap';

export default {
  name: 'GpxEditor',

   components: {
    MainMap,
   },
};
</script>
